import React, { Component } from 'react';
import { Table, TableColumnType } from '../table/Table';
import { UserContext, documentPropNames, documentBpActions, docTypes, docTypeMapping } from '../../constants';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { getFilesContentForSigning, submitSignedFile, getFormSetting, getFormFields } from '../document/DocumentHelpers';
import { SignForm } from './SignForm';
import { AddSignatoryForm } from './AddSignatoryForm';
import * as ModalDialogsTemplates from '../ModalDialogsTemplates'
import i18next from "../../i18n";

const tableSettings = {
    name: "batchSignFormTable",
    columns: [
        {
            "id": "0",
            "name": "Id",
            "headerName": "",
            "type": TableColumnType.String,
            "hidden": true
        },
        {
            id: "1",
            name: "documentName",
            headerName: i18next.t("batchSignForm.cols.documentName"),
            type: TableColumnType.String
        },
        {
            id: "2",
            name: "signCount",
            headerName: i18next.t("batchSignForm.cols.signCount"),
            type: TableColumnType.String
        },
        {
            id: "3",
            name: "hasStamp",
            headerName: i18next.t("batchSignForm.cols.hasStamp"),
            type: TableColumnType.Bool,
            showFalseValue: true
        },
        {
            id: "4",
            name: "additionalSigning",
            headerName: i18next.t("batchSignForm.cols.additionalSigning"),
            type: TableColumnType.Bool,
            showFalseValue: true
        },
        {
            id: "5",
            name: "notSigningReason",
            headerName: i18next.t("batchSignForm.cols.notSigningReason"),
            type: TableColumnType.ColoredString,
            showFalseValue: true
        },
        {
            id: "6",
            name: "notStampSigningReason",
            headerName: i18next.t("batchSignForm.cols.notStampSigningReason"),
            type: TableColumnType.ColoredString
        },
        {
            id: "7",
            name: "sendAbility",
            headerName: i18next.t("batchSignForm.cols.sendAbility"),
            type: TableColumnType.Bool,
            showFalseValue: true
        }
    ]
}

export class BatchSignForm extends Component {
    static contextType = UserContext;

    docForms = {};

    constructor(props) {
        super(props);

        this.state = {
            docIds: props.docIds,
            checkedList: [],
            lastOperationCheckedList: [],
            tableItems: [],
            docProps: [],
            showAdditionalSigningInfo: true,
            dateLoaded: null,
            loaded: false,
            wasSent: false
        };
        
        this.getDocuments = this.getDocuments.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onCheckChanged = this.onCheckChanged.bind(this);
        this.onSend = this.onSend.bind(this);
        this.onSign = this.onSign.bind(this);
        this.onAdditionalSigning = this.onAdditionalSigning.bind(this);
        this.loadDocuments = this.loadDocuments.bind(this);
        this.checkIsDocumentsActual = this.checkIsDocumentsActual.bind(this);
        this.getRequestProps = this.getRequestProps.bind(this);
        this.index = 0;
        this.loadDocuments();        
    }

    loadDocuments() {
        this.getDocuments(this.state.docIds).then(data => {
            if (data && data.resultDocs) {
                let tableItems = [];
                let docProps = [];
                let wasSentDocs = [];
                data.resultDocs.forEach(doc => {
                    let props = JSON.parse(doc.documentProps);
                    tableItems.push(this.getTableItem(doc, props));
                    props.attachments = doc.attachments;
                    docProps[props[documentPropNames.id]] = props;
                    if (doc.wasSent) wasSentDocs.push(props[documentPropNames.id]);
                });
                let actualIds = this.state.docIds.filter(id => tableItems.some(it => it.columns.Id === id));
                let actualcheckedList = this.state.checkedList.filter(id => tableItems.some(it => it.columns.Id === id));

                tableItems.sort((item1, item2) => item1.columns.documentName > item2.columns.documentName ? 1 : -1);

                this.setState({
                    docIds: actualIds,
                    checkedList: actualcheckedList,
                    tableItems: tableItems,
                    docProps: docProps,
                    showAdditionalSigningInfo: data.showAdditionalSigningInfo,
                    dateLoaded: data.dateLoaded,
                    loaded: true
                }, () => {
                    if (this.state.wasSent) this.showDocumentSending(wasSentDocs);
                });
            }
        });
    }

    getTableItem(doc, props) {
        this.index++;

        return {
            columns: {
                Id: props[documentPropNames.id],
                documentName: props[documentPropNames.title],
                notSigningReason: { text: doc.notAllowedSignReason, color: (doc.canSign || doc.canSend) ? "#008000" : "#bf301a" },
                notStampSigningReason: { text: doc.notAllowedStampReason, color: (doc.canStamp || doc.canSend) ? "#008000" : "#bf301a" },
                stampAbility: doc.canStamp,
                signAbility: doc.canSign,
                sendAbility: doc.canSend,
                signCount: doc.signCount.toFixed(),
                hasStamp: doc.hasStamp,
                additionalSigning: doc.canSendToAdditionalSign
            }
        }
    }

    async getDocuments(docIds) {
        let data = null;
        if (docIds) {
            data = await fetch('/Document/GetBatchOperationInfos', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(docIds)
            })
                .then(async response => {
                    if (response.ok) {
                        let result = await response.json();
                        return result;
                    }
                });
        }
        if (data.errorText) {
            ModalDialogsTemplates.messageDialog(i18next.t("error"), data.errorText, () => { }, 'modalSubDialog');
        }
        return data;
    }

    async checkIsDocumentsActual(docIds) {
        let result = false;
        if (docIds) {
            const data = await fetch(`/Document/CheckIsDocumentsActual?loadedDate=${this.state.dateLoaded}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(docIds)
            })
                .then(async response => {
                    if (response.ok) {
                        let result = await response.json();
                        return result;
                    }
                    else {
                        return false;
                    }
                });
            if (data.notActualDocIds?.length === 0) result = true;
        }
        return result;
    }

    onClose() {
        if (this.props.onClose)
            this.props.onClose();
    }

    onCheckChanged(checkedList) {
        this.setState({ checkedList: checkedList });
    }

    async updateDocument(id, action, requestProps) {
        let response = await fetch(`Document/Update/${id}?actionDoc=${action}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestProps),
        })
        if (!response.ok) return false;
        else {
            const data = await response.json();
            if (!data.checkResult.success) return false;
        }
        return true;
    }

    async onSend() {
        const { checkedList, docProps } = this.state;

        const isActual = await this.checkIsDocumentsActual(checkedList);

        if (isActual) {
            let message = i18next.t("actionCompleteMessages.docsSuccessfullySended");
            let errorMessage = i18next.t("actionCompleteMessages.batchSendError");
            let hasErrors = false;

            for (const id of checkedList) {
                let currentDocProps = docProps[id];
                if (currentDocProps) {
                    let action = documentBpActions.approve;
                    let docType = currentDocProps[documentPropNames.type];
                    if (docType === docTypes.sourcedocument)
                        action = documentBpActions.send;

                    const requestProps = await this.getRequestProps(currentDocProps);
                    if (requestProps) {
                        let result = await this.updateDocument(id, action, requestProps);
                        hasErrors = hasErrors || !result;
                    }
                    else {
                        hasErrors = true;
                    }
                }
            }
            let lastOperationCheckedList = [...checkedList];
            if (!hasErrors) {
                ModalDialogsTemplates.messageDialog(i18next.t("done"), message, () => {
                    this.setState({ wasSent: true, lastOperationCheckedList }, () => this.loadDocuments());
                }, 'modalSubDialog');
            }
            else {
                ModalDialogsTemplates.messageDialog(i18next.t("error"), errorMessage, () => {
                    this.setState({ wasSent: true, lastOperationCheckedList }, () => this.loadDocuments());
                }, 'modalSubDialog');
            }
        }
        else {
            ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t("actionCompleteMessages.batchNotActualDocsError"), () => this.loadDocuments(), 'modalSubDialog');
        }
    }

    async onAdditionalSigning() {
        const { checkedList, docProps } = this.state;

        let isActual = await this.checkIsDocumentsActual(checkedList);

        if (isActual) {
            const addAdditionaSignatory = async (userIds) => {

                isActual = await this.checkIsDocumentsActual(checkedList);

                if (isActual) {
                    const message = i18next.t("actionCompleteMessages.docsSuccessfullySendedToAdditionalSigning");
                    const errorMessage = i18next.t("actionCompleteMessages.batchSendToAdditionalSigningError");
                    let hasErrors = false;

                    for (let index in checkedList) {
                        const currentDocProps = docProps[checkedList[index]];
                        if (currentDocProps) {
                            const docType = currentDocProps[documentPropNames.type];
                            const action = docType === docTypes.sourcedocument ? documentBpActions.toAdditionalSigning : documentBpActions.additionalSigning;

                            const requestProps = await this.getRequestProps(currentDocProps, userIds);
                            if (requestProps) {
                                const result = await this.updateDocument(checkedList[index], action, requestProps);
                                hasErrors = hasErrors || !result;
                            }
                            else {
                                hasErrors = true;
                            }
                        }
                        else
                            hasErrors = true;
                    }
                    let lastOperationCheckedList = [...checkedList];
                    if (!hasErrors) {
                        ModalDialogsTemplates.messageDialog(i18next.t("done"), message, () => {
                            this.setState({ wasSent: true, lastOperationCheckedList }, () => this.loadDocuments());
                        }, 'modalSubDialog');
                    }
                    else {
                        ModalDialogsTemplates.messageDialog(i18next.t("error"), errorMessage, () => {
                            this.setState({ wasSent: true, lastOperationCheckedList }, () => this.loadDocuments());
                        }, 'modalSubDialog');
                    }
                }
                else {
                    ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t("actionCompleteMessages.batchNotActualDocsError"), () => this.loadDocuments(), 'modalSubDialog');
                }
            }
            showModalDialog('modalSubDialog', i18next.t("additionalSignatories"), "",
                <AddSignatoryForm
                    companyName={this.props.companyShortName}
                    handleAddSignatory={(userIds) => addAdditionaSignatory(userIds)}
                    handleFormClose={() => hideModalDialog('modalSubDialog')}
                />,
                "feedPopup middle-size");
        }
        else {
            ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t("actionCompleteMessages.batchNotActualDocsError"), () => { this.loadDocuments(); }, 'modalSubDialog');
        }
    }

    async onSign(isStamp) {
        const { checkedList, docProps } = this.state;

        let message = isStamp ? i18next.t("actionCompleteMessages.docsSuccessfullyStamped") : i18next.t("actionCompleteMessages.docsSuccessfullySigned");
        let errorMessage = isStamp ? i18next.t("actionCompleteMessages.batchStampError") : i18next.t("actionCompleteMessages.batchSignError");
        let hasErrors = false;

        let files = [];
        let filesMapping = {};

        let isActual = await this.checkIsDocumentsActual(checkedList);

        if (isActual) {
            for (const id of checkedList) {
                let currentDocProps = docProps[id];
                if (currentDocProps) {
                    let docType = currentDocProps[documentPropNames.type];
                    files.push({ id: id, title: currentDocProps[documentPropNames.title], type: docTypeMapping.find(t => t.docType === docType).alfrescoType, isMain: true });
                    filesMapping[id] = id;
                    if (docType === docTypes.request || docType === docTypes.simplerequest || docType === docTypes.certificate) {
                        currentDocProps.attachments.forEach((attachmentId, index) => {
                            files.push({ id: attachmentId });
                            filesMapping[attachmentId] = id;
                        });
                    }
                }
            }
            let fielesContent = await getFilesContentForSigning(files, true);
            if (fielesContent) {
                if (fielesContent.length < files.length) {
                    hasErrors = true;
                }

                fielesContent = fielesContent.filter(f => f.file?.content && f.file?.mimeType);

                let handlerRestart = () => {
                    let onClose = () => {
                        hideModalDialog('modalSubDialogError');
                        this.onSign(isStamp);
                    }
                    let message = isStamp ? i18next.t("0") : i18next.t("1");
                    showModalDialog('modalSubDialogError', i18next.t("error"), "", <div className="info-message">{message}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: onClose, class: "btn-primary" }], onClose);
                }
                let showResult = () => {
                    if (!hasErrors) {
                        ModalDialogsTemplates.messageDialog(i18next.t("done"), message, () => { this.loadDocuments(); }, 'modalSubDialog');
                    }
                    else {
                        ModalDialogsTemplates.messageDialog(i18next.t("error"), errorMessage, () => { this.loadDocuments(); }, 'modalSubDialog');
                    }
                }
                let onSignHandler = async (signs) => {
                    isActual = await this.checkIsDocumentsActual(checkedList);
                    if (isActual) {
                        for (let j = 0; j < signs.length; ++j) {
                            let file = fielesContent.find(item => item.id === signs[j].id);
                            let submitResult = await submitSignedFile(file, signs[j]);
                            hasErrors = hasErrors || !submitResult;
                        }
                        showResult();
                    }
                    else {
                        ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t("actionCompleteMessages.batchNotActualDocsError"), () => { this.loadDocuments(); }, 'modalSubDialog');
                    }
                }

                if (fielesContent.length > 0) {
                    let withoutStamp = !isStamp;
                    let withoutSign = isStamp;
                    showModalDialog('modalSubDialog', i18next.t("digitalSignature"), "",
                        <SignForm files={fielesContent}
                            handlerRestart={handlerRestart.bind(this)}
                            onSignHandler={onSignHandler.bind(this)}
                            onCloseHandler={() => { hideModalDialog('modalSubDialog'); }}
                            withoutStamp={withoutStamp}
                            withoutSign={withoutSign}
                            errorDialogId="modalSubDialog"
                            notShowError={true}
                        />,
                        "feedPopup middle-size", true, [], () => { hideModalDialog('modalSubDialog'); });
                }
                else
                    showResult();
            }
            else {
                ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t("actionCompleteMessages.batchSignLoadDocumentsError"), () => { this.loadDocuments(); }, 'modalSubDialog');
            }
        }
        else {
            ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t("actionCompleteMessages.batchNotActualDocsError"), () => { this.loadDocuments(); }, 'modalSubDialog');
        }
    }

    async getRequestProps(docProps, externalSignerIds = '') {
        const docType = docProps[documentPropNames.type];

        const form = this.docForms[docType] ?? (await getFormSetting(docTypeMapping.find(t => t.docType === docType)?.alfrescoType, false))?.form;
        if (!form) return;
        this.docForms[docType] = form;

        let properties = {};
        Object.keys(docProps).forEach((key) => {
            properties["prop_" + key.replaceAll(":", "_").replace("-", "_")] = docProps[key];
        });

        properties = getFormFields(form, properties);

        if (externalSignerIds) properties.assoc_sxcfc_externalSigners_added = externalSignerIds;
        
        const requestProps = {
            properties: JSON.stringify(properties),
            type: docTypeMapping.find(m => m.docType === docType).alfrescoType
        };

        return requestProps;
    }

    showDocumentSending(wasSentDocs) {
        let { docIds, checkedList, lastOperationCheckedList, tableItems, docProps } = this.state;

        let wasSentFromChecked = wasSentDocs.filter(id => lastOperationCheckedList.includes(id));
        docIds = docIds.filter(id => !wasSentFromChecked.includes(id));
        tableItems = tableItems.filter(it => !wasSentFromChecked.includes(it.columns.Id));
        wasSentFromChecked.forEach(id => {
            delete docProps[id];
            const rowId = 'table_row_' + id;
            const row = document.getElementById(rowId);
            if (row) {
                row.classList.add('sending');
                row.classList.remove('active');
                const sendingBlock = document.createElement('div');
                sendingBlock.classList.add('sending-block');
                row.appendChild(sendingBlock);
            }
        });
        checkedList = checkedList.filter(id => !wasSentFromChecked.includes(id));;
        setTimeout(() => {
            this.setState({ docIds: docIds, tableItems: tableItems, docProps: docProps, checkedList: checkedList, lastOperationCheckedList: [], wasSent: false });
        }, 400);
    }


    render() {
        const { tableItems, checkedList, showAdditionalSigningInfo, loaded, wasSent } = this.state;
        const canSign = checkedList.length > 0 && !tableItems.some(item => checkedList.includes(item.columns.Id) && !item.columns.signAbility);
        const canStamp = checkedList.length > 0 && !tableItems.some(item => checkedList.includes(item.columns.Id) && !item.columns.stampAbility);
        const canSend = checkedList.length > 0 && !tableItems.some(item => checkedList.includes(item.columns.Id) && !item.columns.sendAbility);
        const canSendToAdditionalSign = checkedList.length > 0 && !tableItems.some(item => checkedList.includes(item.columns.Id) && !item.columns.additionalSigning);

        if (!showAdditionalSigningInfo) {
            tableSettings.columns = tableSettings.columns.filter(c => c.name !== "additionalSigning");
        }

        return (
            <>
                <div className="modal-body scrollYInner">
                    {tableItems.length > 0 && <Table name={tableSettings.name} columns={tableSettings.columns} items={tableItems} onCheckChangeHandler={this.onCheckChanged} />}
                    {loaded && tableItems.length === 0 && <div className="batch-not-found" style={{ textAlign: "center" }} >{i18next.t("batchDocumentsNotFound")}</div>}
                </div>
                <br />
                <div className="modal-footer">
                    <div className="form-group form-group__last">
                        {canSign && !wasSent ? <button type="button" className="btn btn-primary" onClick={() => this.onSign(false)}>{i18next.t("batchSign")}</button> :
                            <button type="button" className="btn btn-primary" disabled="disabled">{i18next.t("batchSign")}</button>
                        }
                        {showAdditionalSigningInfo &&
                            (canSendToAdditionalSign && !wasSent ? <button type="button" className="btn btn-primary" onClick={this.onAdditionalSigning} >{i18next.t("forAdditionalSigning")}</button> :
                                <button type="button" className="btn btn-primary" disabled="disabled">{i18next.t("forAdditionalSigning")}</button>
                            )
                        }
                        {canStamp && !wasSent ? <button type="button" className="btn btn-primary" onClick={() => this.onSign(true)}>{i18next.t("addStamp")}</button> :
                            <button type="button" className="btn btn-primary" disabled="disabled">{i18next.t("addStamp")}</button>
                        }
                        {canSend && !wasSent ? <button type="button" className="btn btn-primary" onClick={this.onSend}>{i18next.t("sendTo")}</button> :
                            <button type="button" className="btn btn-primary" disabled="disabled">{i18next.t("sendTo")}</button>
                        }
                        <button type="button" className="btn btn-secondary" onClick={this.onClose} >{i18next.t("close")}</button>
                    </div>
                </div>
            </>
        );
    }
}